import * as React from 'react';
import { withStyles, WithStyles, StyleRules } from '@mui/styles';
import { Theme } from '@mui/styles';
import { Popper, Paper, Fade } from '@mui/material'
import { PopperPlacementType } from '@mui/material/Popper'
import { ClickAwayListener } from '@mui/material';
import classNames from 'classnames';

const styles = (theme: Theme): StyleRules => ({
})

interface Props extends React.HTMLProps<HTMLDivElement> {
    icon: string;
    anchorHTML?: string;
    iconStyle?: any;
    timeout?: number;
    click?: boolean;
    placement?: PopperPlacementType;
    anchorStyle?: any;
}

type State = {
    open: boolean
};

class Poptart extends React.Component<Props & WithStyles<keyof typeof styles>, State> {
    _keepShowing: boolean;
    anchorEl: any;
    constructor(props: Props & WithStyles<keyof typeof styles>) {
        super(props, {})
        this.state = {
            open: false
        };
        this._keepShowing = false;
    }

    onMouseOver = () => {
        this.setState({
            open: true
        })
    }

    onMouseOut = () => {
        setTimeout(() => {
            if (!this._keepShowing) {
                this.setState({
                    open: false
                })
            }
        }, 250)
    }

    keepShowing = () => {
        this._keepShowing = true
        this.setState({
            open: true
        })
    }

    stopShowing = () => {
        this._keepShowing = false
        this.setState({
            open: false
        })
    }

    togglePopper = () => {
        this.setState({
            open: !this.state.open
        })
    }

    handleClickAway = () => {
        if (this.state.open) {
            this.setState({
                open: false
            })
        }
    }

    render() {
        const { children, click, timeout, placement, icon, iconStyle, anchorHTML, className } = this.props
        const { open } = this.state
        
        if (!children) {
            // console.log("Ejecting Poptart")
            return null
        }
        return (
            <div>
                <ClickAwayListener onClickAway={this.handleClickAway}>
                    <div>
                        {!anchorHTML && <i
                            ref={node => {
                                this.anchorEl = node;
                            }}
                            className={classNames(icon, className)}
                            style={iconStyle || {}}
                            onMouseOver={click ? undefined : this.onMouseOver}
                            onMouseOut={click ? undefined : this.onMouseOut}
                            onClick={click ? this.togglePopper : undefined}
                        />}
                        {anchorHTML && <div
                            ref={node => {
                                this.anchorEl = node;
                            }}
                            style={this.props.anchorStyle}
                            dangerouslySetInnerHTML={{ __html: anchorHTML }}
                            onMouseOver={click ? undefined : this.onMouseOver}
                            onMouseOut={click ? undefined : this.onMouseOut}
                            onClick={click ? this.togglePopper : undefined}
                        ></div>}
                        <Popper
                            className="poptart-popper"
                            style={{ zIndex: 99999 }}
                            placement={placement || "left-start"}
                            open={open}
                            anchorEl={this.anchorEl}
                            transition
                        >
                            {({ TransitionProps }) => (
                                <Fade {...TransitionProps} timeout={timeout || 350}>
                                    <Paper onMouseOver={click ? undefined : this.keepShowing} onMouseOut={click ? undefined : this.stopShowing}>
                                        {children}
                                    </Paper>
                                </Fade>
                            )}
                        </Popper>
                    </div>
                </ClickAwayListener>
            </div>
        );
    }
}

export default withStyles(styles)(Poptart);
